import React, { Component } from 'react';
import MyMessage from "../../../components/Message/index";

const pStyle = {
  textAlign: 'center',
  color: 'red',
  display: 'inline'
};

export default class MessageError extends Component {
  render() {
    return (
      <MyMessage textAlign={this.props.textAlign} style={pStyle} message={this.props.message} icon={this.props.icon} iconName='cancel'/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/MessageError/index.js